import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import jaro from 'jaro-winkler'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'
import PatternThumbnail from '../components/PatternThumbnail/PatternThumbnail.js'

import { tryToGetOfficialPatterns, tryToLog } from '../actions/actions.export.js'

import generateName from '../pattern_utilities/generateName.js'
import canI from '../canI.js'


class SearchResults extends Component {

  constructor(props){
    super(props)

    this.state = {
      term: "",
      filteredPatterns: []
    }

    this.handleUpdateSearch = this.handleUpdateSearch.bind(this);
  }

  componentWillMount(){
    const { user, dispatch } = this.props;

    dispatch(tryToGetOfficialPatterns());
  }

  componentDidMount(){
    window.document.title = "Search results - Pattycake";
  }

  componentWillReceiveProps(newProps){

    if(newProps.match.params.term && !newProps.patternManager.tryingToGetOfficialPatterns){
      if(newProps.match.params.term !== this.state.term){
        this.setState({term: newProps.match.params.term});
        setTimeout(this.handleUpdateSearch);
      }
    }
  }

  handleUpdateSearch(){
    const { user, team, patternManager, dispatch } = this.props;

    if(patternManager.tryingToGetOfficialPatterns) return;

    let canAccessTemplates = canI(user, team, 'calculator_access', team.current);
    let canAccessLibrary = canI(user, team, 'library_access', team.current);
    let canAccessProLibrary = canI(user, team, 'pro_library_access', team.current);

    let patterns = patternManager.officialLibrary;

    let filteredPatterns = [];

    if(this.state.term !== ''){

      let lowercaseTerm = this.state.term.toLowerCase();

      for(var i = 0; i < patterns.length; i++){
        let p = patterns[i];

        let match = false;

        if(generateName(patternManager.pristineCache[p]).toLowerCase().indexOf(lowercaseTerm) > -1){
          match = true;
        }
        if((patternManager.pristineCache[p].tags || []).join(' ').toLowerCase().indexOf(lowercaseTerm) > -1){
          match = true;
        }
        if((patternManager.pristineCache[p].projects || []).join(' ').toLowerCase().indexOf(lowercaseTerm) > -1){
          match = true;
        }
        if(patternManager.pristineCache[p].description.toLowerCase().indexOf(lowercaseTerm) > -1){
          match = true;
        }

        let tags = patternManager.pristineCache[p].tags || [];
        for(var j in tags){
          if(jaro(tags[j].toLowerCase(), lowercaseTerm) > .9){
            match = true;
            break;
          }
        }

        if(match){
          
          let proOnly = patternManager.pristineCache[p].projects.indexOf('Pro Only') > -1;
          let preHeat = patternManager.pristineCache[p].projects.indexOf('Preheat') > -1;
          let template = patternManager.pristineCache[p].projects.indexOf('Pattycake Templates') > -1;

          let locked = false;
          let wouldBeLocked = false;

          if(!preHeat){
            if(proOnly){
              wouldBeLocked = true;
              if(canAccessProLibrary){
                locked = false;
              } else {
                locked = true;
              }
            } else if(template){
              if(canAccessTemplates){
                locked = false;
              } else {
                locked = true;
              }
            }
          }

          filteredPatterns.push({
            cacheID: p,
            locked: locked,
            wouldBeLocked: wouldBeLocked
          });
          continue;
        }
      }
    }

    filteredPatterns.sort((a,b)=>{
      let an = patternManager.pristineCache[a.cacheID].name;
      let bn = patternManager.pristineCache[b.cacheID].name;
      if(an < bn) return -1;
      if(an > bn) return 1;
      return 0;
    })

    filteredPatterns.sort((a,b)=>{
      let an = a.locked;
      let bn = b.locked
      if(an < bn) return -1;
      if(an > bn) return 1;
      return 0;
    })

    this.setState({
      filteredPatterns: filteredPatterns
    });

    let lockedCount = filteredPatterns.filter(p => p.locked).length;
    let wouldBeLockedCount = filteredPatterns.filter(p => p.wouldBeLocked).length;

    dispatch(tryToLog({
      message: "Searched: `" + this.state.term + "`: found *" + filteredPatterns.length + "* total,  *" + (filteredPatterns.length - wouldBeLockedCount) + "* free and *" + wouldBeLockedCount + "* Pro Only."
    }));
  }


  render(){
    const { user, team, patternManager } = this.props;


    let canAccessTemplates = canI(user, team, 'calculator_access', team.current);
    let canAccessLibrary = canI(user, team, 'library_access', team.current);
    let canAccessProLibrary = canI(user, team, 'pro_library_access', team.current);

    return <div className="landing">
      <div className="screen-height-container">
        <div className="shc-content">
          <Header/>

          {
            (patternManager.tryingToGetOfficialPatterns || patternManager.officialLibrary.length == 0) ? 

            <div className="container">
              <div className="row row-padded" id="what">
                <div className="col-md-12">
                  <div className="section-label">
                    <i className="fas fa-spinner-third fa-spin fa-spin"/> &nbsp;LOADING
                  </div>
                </div>
              </div>
            </div>
            :
            <div className="container">
              <div className="row row-padded" id="what">
                <div className="col-md-12">
                  <div className="section-label">
                    RESULTS
                  </div>
                </div>
                <div className="col-md-6">
                  <h2><strong>search:</strong> {this.state.term}</h2>
                  
                  <p className="lead soft">
                    <strong>Found {this.state.filteredPatterns.length} pattern{ this.state.filteredPatterns.length != 1 ? "s" : ""}</strong>
                    <br/>Don't see what you're looking for?
                    <br/>Pattycake makes it easier than ever to create the perfect hatch pattern.
                  </p>
                  
                </div>
                <div className="col-md-6">
                  {
                    !user.isLoggedIn &&
                    <div className="col-themed list-left">
                      {
                        this.state.filteredPatterns.length === 0 ?
                        <p className="no-margin-bottom">
                          Sign up to make the pattern you need, easier than ever before.
                        </p>
                        :
                        <p className="no-margin-bottom">
                          Sign up to access hundreds of amazing patterns - all created with Pattcake.
                        </p> 
                      }
                      <Link to="/sign-up" className="button-link">
                        <Button
                          display="Sign Up for Free"
                          color="primary"
                          
                          />
                      </Link>
                    </div>
                  }
                </div>
              </div>
              <div className="row row-padded">
                {
                  this.state.filteredPatterns.map((p, i)=>{


                    return <div className="col-md-3" key={i}>
                      <PatternThumbnail 
                        cacheID={p.cacheID} 
                        light={true}
                        simple={true}
                        locked={p.locked}
                        lockedMessage="This pattern is unlocked with a Pro, Firms, or Enterprise account."
                        registerBeforeNavigating={!user.isLoggedIn}
                        registerBeforeNavigatingIntro="The perfect pattern"
                        registerBeforeNavigatingTagline="Sign up for free, no tricks just treats."  
                        registerBeforeNavigating={true}      
                        />
                    </div>
                  })
                }
              </div>
            </div>
          }
        </div>
      </div>
      <Footer/>
    </div>
  }
}


const mapStateToProps = (state) => {
  const { 
    user,
    team,
    patternManager
  } = state;

  return {
    user,
    team,
    patternManager
  }
}

export default connect(mapStateToProps)(SearchResults);


// WEBPACK FOOTER //
// ./src/routes/SearchResults.js